import { render, staticRenderFns } from "./ProblemFour.vue?vue&type=template&id=29f0bfaf&scoped=true&"
import script from "./ProblemFour.vue?vue&type=script&lang=ts&"
export * from "./ProblemFour.vue?vue&type=script&lang=ts&"
import style0 from "./ProblemFour.vue?vue&type=style&index=0&id=29f0bfaf&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29f0bfaf",
  null
  
)

export default component.exports